import { render, staticRenderFns } from "./SoldSerial.vue?vue&type=template&id=ccef3aa8&scoped=true&"
import script from "./SoldSerial.vue?vue&type=script&lang=js&"
export * from "./SoldSerial.vue?vue&type=script&lang=js&"
import style0 from "./SoldSerial.vue?vue&type=style&index=0&id=ccef3aa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccef3aa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VDataTable,VDivider,VProgressLinear,VSpacer,VTextField})
